import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";
import { CollapsibleDetails, CollapsibleRow, CollapsibleSummary } from "@shared/table/CollapsibleRow";
import { flexRender, Row } from "@tanstack/react-table";

import { useStyles } from "./ReleaseNotesPage.style";
import { ReleasedImage } from "./types";

type Props = {
    row: Row<ReleasedImage>;
};

export const ReleaseNotesRow = ({ row }: Props) => {
    const { t } = useTranslation(["pages"]);
    const { classes } = useStyles();

    return (
        <CollapsibleRow>
            <CollapsibleSummary row={row}>
                {row
                    .getVisibleCells()
                    .map((cell) => flexRender(cell.column.columnDef.cell, { ...cell.getContext(), key: cell.id }))}
            </CollapsibleSummary>
            <CollapsibleDetails>
                {row.original.changes.length > 0 ? (
                    row.original.changes.map((change, index) => (
                        <Typography key={index} className={classes.changeLog}>
                            - {change}
                        </Typography>
                    ))
                ) : (
                    <Typography>{t("pages:releaseNotesPage.noReleasesChanges")}</Typography>
                )}
            </CollapsibleDetails>
        </CollapsibleRow>
    );
};
